import { render, staticRenderFns } from "./menuDocument.vue?vue&type=template&id=575c664b&scoped=true&"
import script from "./menuDocument.vue?vue&type=script&lang=js&"
export * from "./menuDocument.vue?vue&type=script&lang=js&"
import style0 from "./menuDocument.vue?vue&type=style&index=0&id=575c664b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575c664b",
  null
  
)

export default component.exports